import { Controller } from 'stimulus';
import Mustache from 'mustache';
import Moment from 'moment';
const Highcharts = require('highcharts/highstock');
require('highcharts/modules/exporting')(Highcharts);

const PARAMS = {
  chartDataUrl: 'https://tools.eurolandir.com/tools/pricefeed/history.aspx?companycode=sf-rut&format=json&currency=EUR&period=365',
  infoDataUrl: 'https://tools.eurolandir.com/tools/pricefeed/?companycode=sf-rut&format=json&currency=EUR',
  chartData: null,
  infoData: null,
  infoDataKey: window?.localizations?.investors_chart_key || 'Raute (HEL)',
}

export default class extends Controller {
  static targets = [
    'chart',
    'infoTop',
    'infoBottom',
    'infoTopTemplate',
    'infoBottomTemplate',
  ];

  /**
   * Automatically called when stimulus has initialized controller
   */
  initialize() {
    this.getData(PARAMS.chartDataUrl);
  }

  /*
    0: 1549895400000
    1: 42.36
  */
  formatData(data) {
    PARAMS.chartData = data['1822']?.Data.map(item => {
      return [Math.floor(new Date(item.Date)), +item.Open];
    });
  }

  getData(url) {
    fetch(url)
      .then(res => res.json())
      .then((data) => {
        fetch(PARAMS.infoDataUrl)
          .then(res2 => res2.json())
          .then((data2) => {
            PARAMS.infoData = data2[PARAMS.infoDataKey];
            this.render(this.formatData(data));
          })
          .catch(err2 => { throw err2 });
      })
      .catch(err => { throw err });
  }

  render() {
    this.renderInfo();
    Highcharts.stockChart(this.chartTarget, {
      rangeSelector: null,
      colors: [
        '#00b51a'
      ],
      exporting: {
        enabled: false
      },
      navigator: {
        enabled: false
      },
      yAxis: {
        opposite: false,
        title: {
          text: 'EUR',
          rotation: 0,
          margin: -25,
          align: 'high'
        },
      },
      xAxis: {
        type: 'datetime',
        tickInterval: 1000 * 3600 * 24 * 30, // 1 month
        step: 1,
        labels: {
          formatter: function() {
            return Highcharts.dateFormat('%b', this.value);
          }
        }
      },
      scrollbar: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      series: [{
        name: 'EUR',
        data: PARAMS.chartData,
        tooltip: {
          valueDecimals: 2
        },
      }]
    });
  }

  formatInfoData(data) {
    if (!data) return null;
    return {
      ...data,
      title: PARAMS.infoDataKey,
      price: (+data.Last).toFixed(2),
      percent: `${(+data.Change).toFixed(2)} (${(+data.ChangePercent).toFixed(2)}%)`,
      updatedOn: Moment(data.Date).format('DD.MM.YYYY, hh:mm A'),
      // shareCapital: data.NoShares
    }
  }

  renderInfo() {
    let data = this.formatInfoData(PARAMS.infoData);

    if (data) {
      this.infoTopTarget.innerHTML = Mustache.render(this.infoTopTemplateTarget.innerHTML, { data });
      this.infoBottomTarget.innerHTML = Mustache.render(this.infoBottomTemplateTarget.innerHTML);
    }
  }

}
